import { render, staticRenderFns } from "./Countrysetup.vue?vue&type=template&id=58319e58"
import script from "./Countrysetup.vue?vue&type=script&lang=js"
export * from "./Countrysetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports